export const getRespuestaREST = (state) => {
  return state.dataResponse;
};
export const loggingIn = (state) => {
  return state.token == null ? false : true;
};
export const toggleModal = (state) => {
  return state.showModal;
};
export const toggleLoading = (state) => {
  return state.Loading;
};
export const imgEmpleado = (state) => {
  return state.imgEmpleado;
};
export const getRespuestaFlagREST = (state) => {
  return state.flagResponse;
};
export const getByNombre = (state) => (nombre) => {
  return state[nombre];
};
export const getDataRaw = (state) => {
  return state.dataRaw;
};

export const getDataEndosos = (state) => {
  return state.dataEndosos;
};
export const getCatLineas = (state) => {
  return state.catLineas;
};
export const getMaxRenglones = (state) => state.maxRenglones;

export const getDatosEndosoCreado = (state) => state.datosEndosoCreado;
